/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.191.0-v202609092247-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqTableDefinitionsApiClass {
 
   constructor() {}

  /**
   * @summary Add one or more columns to a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @param {string} [recomputeColumnType=PROVIDED_WITH_DEPENDENTS] - How to handle table recomputation.
   * @param {boolean} [includeDetailedResults] - True if the detailed rule evaluation results should be included in the response. Default is false.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public addColumnsToTableDefinition(
    body: models.ColumnDefinitionInputListV1,
    {
      id,
      recomputeColumnType,
      includeDetailedResults
    } : {
      id: string,
      recomputeColumnType?: AddColumnsToTableDefinitionRecomputeColumnTypeEnum,
      includeDetailedResults?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/columns`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['recomputeColumnType']: recomputeColumnType,      ['includeDetailedResults']: includeDetailedResults
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableComputeOutputV1>;
  }

  /**
   * @summary Add one or more overrides to a column in a materialized table.  Any existing overrides will be replaced.
   * @param {string} id - The Seeq ID for the table definition
   * @param {string} columnId - The column ID that the overrides are being applied to
  */
  public addOverridesToColumn(
    body: models.ColumnOverrideInputListV1,
    {
      id,
      columnId
    } : {
      id: string,
      columnId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (columnId === null || columnId === undefined) {
      throw new Error("'columnId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}/overrides`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{columnId}', encodeURIComponent(String(columnId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableComputeOutputV1>;
  }

  /**
   * @summary Archive a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the table definition to archive
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public archiveTableDefinition(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Archive all of a table's stale items. A stale item is one that was created by a table but does not currently exist within any column. Does not affect items that are still in use, nor the table itself. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the table definition whose stale items will be archived
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public cleanup(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/cleanup`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.DatasourceCleanUpOutputV1>;
  }

  /**
   * @summary Create a new table definition. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createTableDefinition(
    body: models.TableDefinitionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputV1>;
  }

  /**
   * @summary Create a new table definition from CSV. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createTableDefinitionFromCSV(
    body: models.TableDefinitionCSVInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/csv/create`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputV1>;
  }

  /**
   * @summary Delete a column from a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @param {string} columnId - The column ID to be deleted
   * @param {boolean} [forceDelete] - Should attempt to force delete column even if validation fails
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public deleteColumnFromTableDefinition(
    {
      id,
      columnId,
      forceDelete
    } : {
      id: string,
      columnId: string,
      forceDelete?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (columnId === null || columnId === undefined) {
      throw new Error("'columnId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{columnId}', encodeURIComponent(String(columnId)));

    const queryParams = {
      ['forceDelete']: forceDelete
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputV1>;
  }

  /**
   * @summary Delete overrides from a table definition
   * @param {string} id - The Seeq ID for the table definition
   * @param {string} columnId - The column ID that contains overrides
   * @param {string} [itemId] - Delete override for the specified item ID
   * @param {string} [datumId] - Delete override for the specified datum ID (requires item ID)
  */
  public deleteOverridesFromColumn(
    {
      id,
      columnId,
      itemId,
      datumId
    } : {
      id: string,
      columnId: string,
      itemId?: string,
      datumId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (columnId === null || columnId === undefined) {
      throw new Error("'columnId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}/overrides`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{columnId}', encodeURIComponent(String(columnId)));

    const queryParams = {
      ['itemId']: itemId,      ['datumId']: datumId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableComputeOutputV1>;
  }

  /**
   * @summary Duplicate a table definition by its ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the table definition to duplicate
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public duplicateTableDefinition(
    body: models.TableDefinitionDuplicateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/duplicate`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputV1>;
  }

  /**
   * @summary Get ancestor node options for a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @param {string} [cursor] - Opaque cursor from a previous response for fetching the next page
   * @param {number} [limit=40] - The pagination limit
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getAncestorNodeOptions(
    {
      id,
      cursor,
      limit
    } : {
      id: string,
      cursor?: string,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/node-options/ancestors`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['cursor']: cursor,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.NodeOptionListOutputV1>;
  }

  /**
   * @summary Get descendant node options for a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @param {number} [ancestorLevel] - The ancestor level whose descendants to return. If not provided, returns descendants of the root node
   * @param {string} [descendantFilter] - Text filter for the child key name
   * @param {string} [cursor] - Opaque cursor from a previous response for fetching the next page
   * @param {number} [limit=40] - The pagination limit
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getDescendantNodeOptions(
    {
      id,
      ancestorLevel,
      descendantFilter,
      cursor,
      limit
    } : {
      id: string,
      ancestorLevel?: number,
      descendantFilter?: string,
      cursor?: string,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/node-options/descendants`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['ancestorLevel']: ancestorLevel,      ['descendantFilter']: descendantFilter,      ['cursor']: cursor,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.NodeOptionListOutputV1>;
  }

  /**
   * @summary Get the table definitions whose Item Finders reference hierarchies built on the given Item Table. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the Item Table
   * @param {number} [offset=0] - The pagination offset
   * @param {number} [limit=40] - The pagination limit
   * @param {Array<string>} [types] - Filter the returned tables to these table types. When omitted, all types are returned
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchyReferencingTables(
    {
      id,
      offset,
      limit,
      types
    } : {
      id: string,
      offset?: number,
      limit?: number,
      types?: GetHierarchyReferencingTablesTypesEnum[]
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/hierarchy-referencing-tables`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['types']: types
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyReferencingTablesOutputListV1>;
  }

  /**
   * @summary Get node option properties for a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @param {number} [ancestorLevel] - The ancestor level of the node whose properties to return. If not provided, targets the root node (or root-level descendants when childKey is specified)
   * @param {string} [childKey] - The child key identifying a specific descendant node. If provided, returns properties of the descendant node at the given ancestor level with this key
   * @param {string} [cursor] - Opaque cursor from a previous response for fetching the next page
   * @param {number} [limit=40] - The pagination limit
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getNodeOptionProperties(
    {
      id,
      ancestorLevel,
      childKey,
      cursor,
      limit
    } : {
      id: string,
      ancestorLevel?: number,
      childKey?: string,
      cursor?: string,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/node-options/properties`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['ancestorLevel']: ancestorLevel,      ['childKey']: childKey,      ['cursor']: cursor,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.NodeOptionPropertyListOutputV1>;
  }

  /**
   * @summary Get a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTableDefinition(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputV1>;
  }

  /**
   * @summary Get a list of table definition metadata for overview/management pages. This endpoint is experimental and may change in future releases.
   * @param {number} [offset=0] - The pagination offset
   * @param {number} [limit=40] - The pagination limit
   * @param {Array<string>} [types] - Filter by table types
   * @param {string} [sortBy=Name] - Sort field (name, workbook, hierarchyCount)
   * @param {boolean} [sortAsc=true] - Sorts the sort field in ascending order when true and descending when false
   * @param {string} [nameSearch] - Filter by table name (partial match, case insensitive)
   * @param {string} [scopedToWorkbook] - Filter by workbook name (partial match, case insensitive). Pass &#x27;00000000-0000-0000-0000-000000000000&#x27; to return only globally scoped items (no workbook).
   * @param {boolean} [includeGloballyScoped] - If true, globally scoped items (items with no workbook) will be included in the results regardless of the scopedToWorkbook parameter. If false, the scopedToWorkbook filter will be applied as normal
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTableDefinitions(
    {
      offset,
      limit,
      types,
      sortBy,
      sortAsc,
      nameSearch,
      scopedToWorkbook,
      includeGloballyScoped
    } : {
      offset?: number,
      limit?: number,
      types?: GetTableDefinitionsTypesEnum[],
      sortBy?: GetTableDefinitionsSortByEnum,
      sortAsc?: boolean,
      nameSearch?: string,
      scopedToWorkbook?: string,
      includeGloballyScoped?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['types']: types,      ['sortBy']: sortBy,      ['sortAsc']: sortAsc,      ['nameSearch']: nameSearch,      ['scopedToWorkbook']: scopedToWorkbook,      ['includeGloballyScoped']: includeGloballyScoped
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputListV1>;
  }

  /**
   * @summary Import a CSV file that can be used to create a table definition and publish table data. This endpoint is experimental and may change in future releases.
   * @param {Blob} [file]
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public importTableCSV(
    {
      file
    } : {
      file?: File
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/csv`;


    const formData = new FormData();
    formData.append('file', file as File, file?.name);

    return axiosInstance.request({
      method: 'post',
      url,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      ...restOverrides
    }) as AxiosPromise<models.ImportTableCSVOutputV1>;

    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ImportTableCSVOutputV1>;
  }

  /**
   * @summary Modify a column in a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @param {string} columnId - The column ID to be modified. Possible modifications are: changing the column&#x27;s index, renaming the column, changing the column&#x27;s type, and updating the column&#x27;s unit of measure. For type conversions:- Boolean to Numeric: False values get converted to 0. True values get converted to 1.- Numeric to Boolean: Non-zero values get converted to true. Otherwise, they get converted to false.- UUID to String: The UUID gets directly converted into string format.- TIMESTAMPTZ to String: The value will be converted to a string in the Postgres date time format (ex. 2023-11-28 14:43:35.170579-08).- Boolean to String: false becomes &#x27;false&#x27; and true becomes &#x27;true&#x27;.- Numeric to String: The values get converted directly to a string. Long numeric values do not have special formatting and just get represented as they are in string format.- Any non-string type to UUID: Values get converted to a UUID value with only zeros.- String to UUID: If the string value is in the correct UUID format, it will be directly converted to ite UUID equivalent. Otherwise, it&#x27;ll be cast to a UUID with all zeros.- UUID to Numeric: The UUID values get converted to numeric by only using the numeric parts of the UUID and excluding hyphens and any non-numeric characters.- Any non-string type to TIMESTAMPTZ: All values get converted to the current time.- String to TIMESTAMPTZ: If the string value is in ISO8601 format, it gets directly cast to a timestamp with the same information. If not, then it gets cast to the epoch timestamp.- TIMESTAMPTZ to Numeric: If no column UOM exists, the conversion retrieves the number of seconds between the timestamp and epoch. Otherwise, the conversion retrieves the value between the timestamp and epoch based on the column&#x27;s UOM.- String to Numeric: The string values will get directly converted into their numeric equivalent. So, &#x27;1&#x27; becomes 1, &#x27;1.5&#x27; becomes 1.5, 1e10 becomes 10000000000. So integers, decimals, and scientific notation is handled. If a string cannot become converted, it will be cast as null.- String to Boolean: If &#x27;false&#x27;, &#x27;f&#x27;, or &#x27;0&#x27;, convert to false. If &#x27;true&#x27;, &#x27;t&#x27;, or &#x27;1&#x27;, convert to true. The string to boolean conversion is case-insensitive.- Any non-numeric and non-string type to Boolean: If the value is not null, then true. Otherwise, convert to false.
   * @param {string} [recomputeColumnType=PROVIDED_WITH_DEPENDENTS] - How to handle table recomputation.
   * @param {boolean} [includeDetailedResults] - True if the detailed rule evaluation results should be included in the response. Default is false.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public modifyColumnInTableDefinition(
    body: models.ColumnDefinitionInputV1,
    {
      id,
      columnId,
      recomputeColumnType,
      includeDetailedResults
    } : {
      id: string,
      columnId: string,
      recomputeColumnType?: ModifyColumnInTableDefinitionRecomputeColumnTypeEnum,
      includeDetailedResults?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (columnId === null || columnId === undefined) {
      throw new Error("'columnId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{columnId}', encodeURIComponent(String(columnId)));

    const queryParams = {
      ['recomputeColumnType']: recomputeColumnType,      ['includeDetailedResults']: includeDetailedResults
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableComputeOutputV1>;
  }

  /**
   * @summary Modify/add a list of columns in a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @param {string} [recomputeColumnType=PROVIDED_WITH_DEPENDENTS] - How to handle table recomputation.
   * @param {boolean} [includeDetailedResults] - True if the detailed rule evaluation results should be included in the response. Default is false.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public modifyColumnsInTableDefinition(
    body: models.ColumnDefinitionBulkEditInputListV1,
    {
      id,
      recomputeColumnType,
      includeDetailedResults
    } : {
      id: string,
      recomputeColumnType?: ModifyColumnsInTableDefinitionRecomputeColumnTypeEnum,
      includeDetailedResults?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/columns/edit`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['recomputeColumnType']: recomputeColumnType,      ['includeDetailedResults']: includeDetailedResults
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableComputeOutputV1>;
  }

  /**
   * @summary Create a preview of a table definition given a subset of row data. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the table definition to create a preview for
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public previewTableDefinition(
    body: models.TableDefinitionPreviewInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/preview`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionPreviewOutputV1>;
  }

  /**
   * @summary Use CSV data to update/add rows to an existing table. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public publishRowsFromCSV(
    body: models.TableDefinitionCSVPublishRowsInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/csv/publish`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionCSVPublishRowsOutputV1>;
  }

  /**
   * @summary Recompute a column and its dependents in a table definition, and provides debug information from the rules evaluated. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @param {string} columnId - The column ID to be recomputed
   * @param {boolean} [includeDetailedResults] - True if the detailed rule evaluation results should be included in the response. Default is false.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public recomputeColumnInTableDefinition(
    body: models.RowIdInputListV1,
    {
      id,
      columnId,
      includeDetailedResults
    } : {
      id: string,
      columnId: string,
      includeDetailedResults?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (columnId === null || columnId === undefined) {
      throw new Error("'columnId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}/recompute`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{columnId}', encodeURIComponent(String(columnId)));

    const queryParams = {
      ['includeDetailedResults']: includeDetailedResults
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableComputeOutputV1>;
  }

  /**
   * @summary Change the order of the columns in a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public reorderColumnsInTableDefinition(
    body: models.ColumnDefinitionOrderInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/column-order`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputV1>;
  }

  /**
   * @summary Update a table definition's name and optionally its description and subscription. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateTableDefinition(
    body: models.TableDefinitionUpdateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputV1>;
  }

  /**
   * @summary Update an existing table definition from a CSV. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateTableDefinitionFromCSV(
    body: models.TableDefinitionCSVUpdateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/table-definitions/${encodeURIComponent(String(id))}/csv/update`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableDefinitionOutputV1>;
  }

}

export const AddColumnsToTableDefinitionRecomputeColumnTypeEnum = {
    ALL: 'ALL',
    PROVIDEDWITHDEPENDENTS: 'PROVIDED_WITH_DEPENDENTS',
    NONE: 'NONE'
} as const;

export type AddColumnsToTableDefinitionRecomputeColumnTypeEnum = typeof AddColumnsToTableDefinitionRecomputeColumnTypeEnum[keyof typeof AddColumnsToTableDefinitionRecomputeColumnTypeEnum];
export const GetHierarchyReferencingTablesTypesEnum = {
    SCALING: 'SCALING',
    SCALINGCSV: 'SCALING_CSV',
    IMPACTREPORT: 'IMPACT_REPORT',
    VANTAGE: 'VANTAGE',
    CAPSULE: 'CAPSULE',
    GENERIC: 'GENERIC',
    FORMULAACROSS: 'FORMULA_ACROSS',
    ITEM: 'ITEM',
    ITEMCSV: 'ITEM_CSV',
    STORED: 'STORED'
} as const;

export type GetHierarchyReferencingTablesTypesEnum = typeof GetHierarchyReferencingTablesTypesEnum[keyof typeof GetHierarchyReferencingTablesTypesEnum];
export const GetTableDefinitionsTypesEnum = {
    SCALING: 'SCALING',
    SCALINGCSV: 'SCALING_CSV',
    IMPACTREPORT: 'IMPACT_REPORT',
    VANTAGE: 'VANTAGE',
    CAPSULE: 'CAPSULE',
    GENERIC: 'GENERIC',
    FORMULAACROSS: 'FORMULA_ACROSS',
    ITEM: 'ITEM',
    ITEMCSV: 'ITEM_CSV',
    STORED: 'STORED'
} as const;

export type GetTableDefinitionsTypesEnum = typeof GetTableDefinitionsTypesEnum[keyof typeof GetTableDefinitionsTypesEnum];
export const GetTableDefinitionsSortByEnum = {
    Name: 'Name',
    Workbook: 'Workbook',
    HierarchyCount: 'HierarchyCount'
} as const;

export type GetTableDefinitionsSortByEnum = typeof GetTableDefinitionsSortByEnum[keyof typeof GetTableDefinitionsSortByEnum];
export const ModifyColumnInTableDefinitionRecomputeColumnTypeEnum = {
    ALL: 'ALL',
    PROVIDEDWITHDEPENDENTS: 'PROVIDED_WITH_DEPENDENTS',
    NONE: 'NONE'
} as const;

export type ModifyColumnInTableDefinitionRecomputeColumnTypeEnum = typeof ModifyColumnInTableDefinitionRecomputeColumnTypeEnum[keyof typeof ModifyColumnInTableDefinitionRecomputeColumnTypeEnum];
export const ModifyColumnsInTableDefinitionRecomputeColumnTypeEnum = {
    ALL: 'ALL',
    PROVIDEDWITHDEPENDENTS: 'PROVIDED_WITH_DEPENDENTS',
    NONE: 'NONE'
} as const;

export type ModifyColumnsInTableDefinitionRecomputeColumnTypeEnum = typeof ModifyColumnsInTableDefinitionRecomputeColumnTypeEnum[keyof typeof ModifyColumnsInTableDefinitionRecomputeColumnTypeEnum];

export const sqTableDefinitionsApi = new sqTableDefinitionsApiClass();

export type sqTableDefinitionsApiEndpoints = {
  'addColumnsToTableDefinition': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/columns';
    response: models.TableComputeOutputV1;
  };
  'addOverridesToColumn': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}/overrides';
    response: models.TableComputeOutputV1;
  };
  'archiveTableDefinition': {
    method: 'delete';
    path: '/table-definitions/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'cleanup': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/cleanup';
    response: models.DatasourceCleanUpOutputV1;
  };
  'createTableDefinition': {
    method: 'post';
    path: '/table-definitions';
    response: models.TableDefinitionOutputV1;
  };
  'createTableDefinitionFromCSV': {
    method: 'post';
    path: '/table-definitions/csv/create';
    response: models.TableDefinitionOutputV1;
  };
  'deleteColumnFromTableDefinition': {
    method: 'delete';
    path: '/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}';
    response: models.TableDefinitionOutputV1;
  };
  'deleteOverridesFromColumn': {
    method: 'delete';
    path: '/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}/overrides';
    response: models.TableComputeOutputV1;
  };
  'duplicateTableDefinition': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/duplicate';
    response: models.TableDefinitionOutputV1;
  };
  'getAncestorNodeOptions': {
    method: 'get';
    path: '/table-definitions/${encodeURIComponent(String(id))}/node-options/ancestors';
    response: models.NodeOptionListOutputV1;
  };
  'getDescendantNodeOptions': {
    method: 'get';
    path: '/table-definitions/${encodeURIComponent(String(id))}/node-options/descendants';
    response: models.NodeOptionListOutputV1;
  };
  'getHierarchyReferencingTables': {
    method: 'get';
    path: '/table-definitions/${encodeURIComponent(String(id))}/hierarchy-referencing-tables';
    response: models.HierarchyReferencingTablesOutputListV1;
  };
  'getNodeOptionProperties': {
    method: 'get';
    path: '/table-definitions/${encodeURIComponent(String(id))}/node-options/properties';
    response: models.NodeOptionPropertyListOutputV1;
  };
  'getTableDefinition': {
    method: 'get';
    path: '/table-definitions/${encodeURIComponent(String(id))}';
    response: models.TableDefinitionOutputV1;
  };
  'getTableDefinitions': {
    method: 'get';
    path: '/table-definitions';
    response: models.TableDefinitionOutputListV1;
  };
  'importTableCSV': {
    method: 'post';
    path: '/table-definitions/csv';
    response: models.ImportTableCSVOutputV1;
  };
  'modifyColumnInTableDefinition': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}';
    response: models.TableComputeOutputV1;
  };
  'modifyColumnsInTableDefinition': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/columns/edit';
    response: models.TableComputeOutputV1;
  };
  'previewTableDefinition': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/preview';
    response: models.TableDefinitionPreviewOutputV1;
  };
  'publishRowsFromCSV': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/csv/publish';
    response: models.TableDefinitionCSVPublishRowsOutputV1;
  };
  'recomputeColumnInTableDefinition': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}/recompute';
    response: models.TableComputeOutputV1;
  };
  'reorderColumnsInTableDefinition': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/column-order';
    response: models.TableDefinitionOutputV1;
  };
  'updateTableDefinition': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}';
    response: models.TableDefinitionOutputV1;
  };
  'updateTableDefinitionFromCSV': {
    method: 'post';
    path: '/table-definitions/${encodeURIComponent(String(id))}/csv/update';
    response: models.TableDefinitionOutputV1;
  };
};

type ApiAddColumnsToTableDefinitionResponse = models.TableComputeOutputV1;
type ApiaddColumnsToTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.addColumnsToTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.addColumnsToTableDefinition>;

export function useApiAddColumnsToTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiAddColumnsToTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApiaddColumnsToTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiAddColumnsToTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApiaddColumnsToTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiaddColumnsToTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.addColumnsToTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiAddOverridesToColumnResponse = models.TableComputeOutputV1;
type ApiaddOverridesToColumnMutationParams = Parameters<typeof sqTableDefinitionsApi.addOverridesToColumn> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.addOverridesToColumn>;

export function useApiAddOverridesToColumnMutation(
  options?: Omit<UseMutationOptions<ApiAddOverridesToColumnResponse, AxiosError<SeeqErrorData>,
    ApiaddOverridesToColumnMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiAddOverridesToColumnResponse, AxiosError<SeeqErrorData>,
  ApiaddOverridesToColumnMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiaddOverridesToColumnMutationParams) =>
      sqTableDefinitionsApi.addOverridesToColumn(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveTableDefinitionResponse = models.ArchiveOutputV1;
type ApiarchiveTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.archiveTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.archiveTableDefinition>;

export function useApiArchiveTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiArchiveTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApiarchiveTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApiarchiveTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.archiveTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCleanupResponse = models.DatasourceCleanUpOutputV1;
type ApicleanupMutationParams = Parameters<typeof sqTableDefinitionsApi.cleanup> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.cleanup>;

export function useApiCleanupMutation(
  options?: Omit<UseMutationOptions<ApiCleanupResponse, AxiosError<SeeqErrorData>,
    ApicleanupMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCleanupResponse, AxiosError<SeeqErrorData>,
  ApicleanupMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApicleanupMutationParams) =>
      sqTableDefinitionsApi.cleanup(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateTableDefinitionResponse = models.TableDefinitionOutputV1;
type ApicreateTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.createTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.createTableDefinition>;
type ApicreateTableDefinitionMutationVariables = models.TableDefinitionInputV1;

export function useApiCreateTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiCreateTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApicreateTableDefinitionMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApicreateTableDefinitionMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateTableDefinitionMutationVariables) =>
      sqTableDefinitionsApi.createTableDefinition(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateTableDefinitionFromCSVResponse = models.TableDefinitionOutputV1;
type ApicreateTableDefinitionFromCSVMutationParams = Parameters<typeof sqTableDefinitionsApi.createTableDefinitionFromCSV> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.createTableDefinitionFromCSV>;
type ApicreateTableDefinitionFromCSVMutationVariables = models.TableDefinitionCSVInputV1;

export function useApiCreateTableDefinitionFromCSVMutation(
  options?: Omit<UseMutationOptions<ApiCreateTableDefinitionFromCSVResponse, AxiosError<SeeqErrorData>,
    ApicreateTableDefinitionFromCSVMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateTableDefinitionFromCSVResponse, AxiosError<SeeqErrorData>,
  ApicreateTableDefinitionFromCSVMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateTableDefinitionFromCSVMutationVariables) =>
      sqTableDefinitionsApi.createTableDefinitionFromCSV(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteColumnFromTableDefinitionResponse = models.TableDefinitionOutputV1;
type ApideleteColumnFromTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.deleteColumnFromTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.deleteColumnFromTableDefinition>;

export function useApiDeleteColumnFromTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiDeleteColumnFromTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApideleteColumnFromTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteColumnFromTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApideleteColumnFromTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteColumnFromTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.deleteColumnFromTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteOverridesFromColumnResponse = models.TableComputeOutputV1;
type ApideleteOverridesFromColumnMutationParams = Parameters<typeof sqTableDefinitionsApi.deleteOverridesFromColumn> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.deleteOverridesFromColumn>;

export function useApiDeleteOverridesFromColumnMutation(
  options?: Omit<UseMutationOptions<ApiDeleteOverridesFromColumnResponse, AxiosError<SeeqErrorData>,
    ApideleteOverridesFromColumnMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteOverridesFromColumnResponse, AxiosError<SeeqErrorData>,
  ApideleteOverridesFromColumnMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteOverridesFromColumnMutationParams) =>
      sqTableDefinitionsApi.deleteOverridesFromColumn(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDuplicateTableDefinitionResponse = models.TableDefinitionOutputV1;
type ApiduplicateTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.duplicateTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.duplicateTableDefinition>;

export function useApiDuplicateTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiDuplicateTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApiduplicateTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDuplicateTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApiduplicateTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiduplicateTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.duplicateTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetAncestorNodeOptionsResponse = models.NodeOptionListOutputV1;
export function GetAncestorNodeOptionsQueryKey(
  params: Parameters<typeof sqTableDefinitionsApi.getAncestorNodeOptions>[0],
) {
  return ['sqTableDefinitionsApi', 'getAncestorNodeOptions', params] as const;
}

export function useApiGetAncestorNodeOptionsQuery(
  params: Parameters<typeof sqTableDefinitionsApi.getAncestorNodeOptions>[0],
  options?: Omit<UseQueryOptions<ApiGetAncestorNodeOptionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAncestorNodeOptionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAncestorNodeOptionsQueryKey(params),
    queryFn: () =>
      sqTableDefinitionsApi.getAncestorNodeOptions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDescendantNodeOptionsResponse = models.NodeOptionListOutputV1;
export function GetDescendantNodeOptionsQueryKey(
  params: Parameters<typeof sqTableDefinitionsApi.getDescendantNodeOptions>[0],
) {
  return ['sqTableDefinitionsApi', 'getDescendantNodeOptions', params] as const;
}

export function useApiGetDescendantNodeOptionsQuery(
  params: Parameters<typeof sqTableDefinitionsApi.getDescendantNodeOptions>[0],
  options?: Omit<UseQueryOptions<ApiGetDescendantNodeOptionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetDescendantNodeOptionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetDescendantNodeOptionsQueryKey(params),
    queryFn: () =>
      sqTableDefinitionsApi.getDescendantNodeOptions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetHierarchyReferencingTablesResponse = models.HierarchyReferencingTablesOutputListV1;
export function GetHierarchyReferencingTablesQueryKey(
  params: Parameters<typeof sqTableDefinitionsApi.getHierarchyReferencingTables>[0],
) {
  return ['sqTableDefinitionsApi', 'getHierarchyReferencingTables', params] as const;
}

export function useApiGetHierarchyReferencingTablesQuery(
  params: Parameters<typeof sqTableDefinitionsApi.getHierarchyReferencingTables>[0],
  options?: Omit<UseQueryOptions<ApiGetHierarchyReferencingTablesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetHierarchyReferencingTablesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetHierarchyReferencingTablesQueryKey(params),
    queryFn: () =>
      sqTableDefinitionsApi.getHierarchyReferencingTables(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetNodeOptionPropertiesResponse = models.NodeOptionPropertyListOutputV1;
export function GetNodeOptionPropertiesQueryKey(
  params: Parameters<typeof sqTableDefinitionsApi.getNodeOptionProperties>[0],
) {
  return ['sqTableDefinitionsApi', 'getNodeOptionProperties', params] as const;
}

export function useApiGetNodeOptionPropertiesQuery(
  params: Parameters<typeof sqTableDefinitionsApi.getNodeOptionProperties>[0],
  options?: Omit<UseQueryOptions<ApiGetNodeOptionPropertiesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetNodeOptionPropertiesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetNodeOptionPropertiesQueryKey(params),
    queryFn: () =>
      sqTableDefinitionsApi.getNodeOptionProperties(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTableDefinitionResponse = models.TableDefinitionOutputV1;
export function GetTableDefinitionQueryKey(
  params: Parameters<typeof sqTableDefinitionsApi.getTableDefinition>[0],
) {
  return ['sqTableDefinitionsApi', 'getTableDefinition', params] as const;
}

export function useApiGetTableDefinitionQuery(
  params: Parameters<typeof sqTableDefinitionsApi.getTableDefinition>[0],
  options?: Omit<UseQueryOptions<ApiGetTableDefinitionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTableDefinitionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTableDefinitionQueryKey(params),
    queryFn: () =>
      sqTableDefinitionsApi.getTableDefinition(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTableDefinitionsResponse = models.TableDefinitionOutputListV1;
export function GetTableDefinitionsQueryKey(
  params: Parameters<typeof sqTableDefinitionsApi.getTableDefinitions>[0],
) {
  return ['sqTableDefinitionsApi', 'getTableDefinitions', params] as const;
}

export function useApiGetTableDefinitionsQuery(
  params: Parameters<typeof sqTableDefinitionsApi.getTableDefinitions>[0],
  options?: Omit<UseQueryOptions<ApiGetTableDefinitionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTableDefinitionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTableDefinitionsQueryKey(params),
    queryFn: () =>
      sqTableDefinitionsApi.getTableDefinitions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiImportTableCSVResponse = models.ImportTableCSVOutputV1;
type ApiimportTableCSVMutationParams = Parameters<typeof sqTableDefinitionsApi.importTableCSV> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.importTableCSV>;

export function useApiImportTableCSVMutation(
  options?: Omit<UseMutationOptions<ApiImportTableCSVResponse, AxiosError<SeeqErrorData>,
    ApiimportTableCSVMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiImportTableCSVResponse, AxiosError<SeeqErrorData>,
  ApiimportTableCSVMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiimportTableCSVMutationParams) =>
      sqTableDefinitionsApi.importTableCSV(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiModifyColumnInTableDefinitionResponse = models.TableComputeOutputV1;
type ApimodifyColumnInTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.modifyColumnInTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.modifyColumnInTableDefinition>;

export function useApiModifyColumnInTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiModifyColumnInTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApimodifyColumnInTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiModifyColumnInTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApimodifyColumnInTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApimodifyColumnInTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.modifyColumnInTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiModifyColumnsInTableDefinitionResponse = models.TableComputeOutputV1;
type ApimodifyColumnsInTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.modifyColumnsInTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.modifyColumnsInTableDefinition>;

export function useApiModifyColumnsInTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiModifyColumnsInTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApimodifyColumnsInTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiModifyColumnsInTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApimodifyColumnsInTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApimodifyColumnsInTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.modifyColumnsInTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPreviewTableDefinitionResponse = models.TableDefinitionPreviewOutputV1;
type ApipreviewTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.previewTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.previewTableDefinition>;

export function useApiPreviewTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiPreviewTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApipreviewTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPreviewTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApipreviewTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApipreviewTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.previewTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPublishRowsFromCSVResponse = models.TableDefinitionCSVPublishRowsOutputV1;
type ApipublishRowsFromCSVMutationParams = Parameters<typeof sqTableDefinitionsApi.publishRowsFromCSV> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.publishRowsFromCSV>;

export function useApiPublishRowsFromCSVMutation(
  options?: Omit<UseMutationOptions<ApiPublishRowsFromCSVResponse, AxiosError<SeeqErrorData>,
    ApipublishRowsFromCSVMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPublishRowsFromCSVResponse, AxiosError<SeeqErrorData>,
  ApipublishRowsFromCSVMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApipublishRowsFromCSVMutationParams) =>
      sqTableDefinitionsApi.publishRowsFromCSV(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRecomputeColumnInTableDefinitionResponse = models.TableComputeOutputV1;
type ApirecomputeColumnInTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.recomputeColumnInTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.recomputeColumnInTableDefinition>;

export function useApiRecomputeColumnInTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiRecomputeColumnInTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApirecomputeColumnInTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRecomputeColumnInTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApirecomputeColumnInTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApirecomputeColumnInTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.recomputeColumnInTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiReorderColumnsInTableDefinitionResponse = models.TableDefinitionOutputV1;
type ApireorderColumnsInTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.reorderColumnsInTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.reorderColumnsInTableDefinition>;

export function useApiReorderColumnsInTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiReorderColumnsInTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApireorderColumnsInTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiReorderColumnsInTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApireorderColumnsInTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApireorderColumnsInTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.reorderColumnsInTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateTableDefinitionResponse = models.TableDefinitionOutputV1;
type ApiupdateTableDefinitionMutationParams = Parameters<typeof sqTableDefinitionsApi.updateTableDefinition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.updateTableDefinition>;

export function useApiUpdateTableDefinitionMutation(
  options?: Omit<UseMutationOptions<ApiUpdateTableDefinitionResponse, AxiosError<SeeqErrorData>,
    ApiupdateTableDefinitionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateTableDefinitionResponse, AxiosError<SeeqErrorData>,
  ApiupdateTableDefinitionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateTableDefinitionMutationParams) =>
      sqTableDefinitionsApi.updateTableDefinition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateTableDefinitionFromCSVResponse = models.TableDefinitionOutputV1;
type ApiupdateTableDefinitionFromCSVMutationParams = Parameters<typeof sqTableDefinitionsApi.updateTableDefinitionFromCSV> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTableDefinitionsApi.updateTableDefinitionFromCSV>;

export function useApiUpdateTableDefinitionFromCSVMutation(
  options?: Omit<UseMutationOptions<ApiUpdateTableDefinitionFromCSVResponse, AxiosError<SeeqErrorData>,
    ApiupdateTableDefinitionFromCSVMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateTableDefinitionFromCSVResponse, AxiosError<SeeqErrorData>,
  ApiupdateTableDefinitionFromCSVMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateTableDefinitionFromCSVMutationParams) =>
      sqTableDefinitionsApi.updateTableDefinitionFromCSV(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
